/* eslint no-debugger: "warn" */

// dependencies
import React from 'react';

import LocalStorageService from './LocalStorageService';

import { API_URL } from "../env";

const currentOrg = LocalStorageService.get('activeOrg');
const currentSite = LocalStorageService.get('activeSite');


class Api extends React.Component {

  _getServerRoot = () => {

    // generally domain bleasdale.behavioursmart.app should point to bleasdale-api.behavioursmart.app
    // get window location host
    const { host } = window.location;

    // check for an override first
    if (API_URL) { return API_URL; }

    // for testing in development
    if (host.includes('localhost')) {
      return 'http://localhost:1337';
    }

    if (host.includes('127.0.0.1')) {
      return 'http://127.0.0.1:1337';
    }

    if (host.includes('-beta.behavioursmart.app')) {
      let subdomain = host.split('.')[0].replace('-beta', '');
      return `https://${subdomain}-api-beta.behavioursmart.app`;
    }

    // fallback for existing beta testing
    if (host.includes('beta.behavioursmart.app')) {
      return 'https://beta-api.behavioursmart.app';
    }

    // vanilla behavioursmart.app domain
    if (host.includes('www.behavioursmart.app')) {
      return 'https://api.behavioursmart.app';
    }

    // segmented subdomain api
    if (host.includes('behavioursmart.app')) {
      let subdomain = host.split('.')[0];
      return `https://${subdomain}-api.behavioursmart.app`;
    }
  }

  login = async (username, password) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    var options = {
      method: 'POST',
      headers,
    };

    const requestUrl = '/api/auth/login';

    options.body = JSON.stringify({
      username,
      password,
    });

    const serverRoot = this._getServerRoot();

    const fullUrl = `${serverRoot}${requestUrl}`;

    const request = new Request(fullUrl, options);
    const response = await fetch(request);
    //
    return response.json();
  };

  myLoginLogin = async code => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    var options = {
      method: 'GET',
      headers,
    };

    const requestUrl = `/api/auth/mylogin?code=${code}`;

    const serverRoot = this._getServerRoot();
    const fullUrl = `${serverRoot}${requestUrl}`;

    const request = new Request(fullUrl, options);
    const response = await fetch(request);
    return response.json();
  };

  myLoginRedirect = () => {
    const serverRoot = this._getServerRoot();
    window.location.href = `${serverRoot}/api/auth/mylogin/redirect`;
  };

  // resetPasswordRequest = async (organisationId, email) => {
  //   const headers = new Headers()
  //   headers.append('Content-Type', 'application/json')
  //   var options = {
  //     method: 'POST',
  //     headers
  //   }
  verifyAccount = async (username, password, verificationCode, rememberMe = false) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    var options = {
      method: 'POST',
      headers,
    };

    const requestUrl = '/api/auth/login';

    options.body = JSON.stringify({
      username,
      password,
      verificationCode,
      rememberMe
    });

    const serverRoot = this._getServerRoot();
    const fullUrl = `${serverRoot}${requestUrl}`;

    const request = new Request(fullUrl, options);
    const response = await fetch(request);

    return response.json();
  };

  resetPassword = async (organisationId, email) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    var options = {
      method: 'POST',
      headers,
    };

    const requestUrl = '/send-reset-link';
    let urlParams = `?email=${encodeURIComponent(email)}`;
    if (organisationId) {
      urlParams = `${urlParams}&organisationId=${encodeURIComponent(
        organisationId,
      )}`;
    }

    const serverRoot = this._getServerRoot();
    const fullUrl = `${serverRoot}${requestUrl}${urlParams}`;

    const request = new Request(fullUrl, options);
    const response = await fetch(request);

    return response.json();
  };

  // TODO: for now, you need to supply the apiToken
  // this is dumb and need to be refactored
  get = async (apiToken, url, params = {}) => {
    // check for an api key, otherwise throw an error

    const currentOrg = LocalStorageService.get('activeOrg');

    // use the apiToken from localstorage instead
    apiToken = LocalStorageService.get('apiToken');

    const options = {
      method: 'GET',
    };

    if (apiToken) {
      options.headers = new Headers();
      options.headers.append('x-api-token', apiToken);
    }

    if (currentOrg) {
      params.orgId = currentOrg.id;
    }

    let paramsStr = '';
    if (params) {
      paramsStr = '';
      for (let key in params) {
        let value = params[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        if (paramsStr === '') {
          paramsStr += '?';
        } else {
          paramsStr += '&';
        }
        paramsStr += `${key}=${value}`;
      }
    }

    const serverRoot = this._getServerRoot();
    const request = new Request(`${serverRoot}${url}${paramsStr}`, options);
    const response = await fetch(request);
    return response.json();
  };

  getPlain = async (url) => {
    // check for an api key, otherwise throw an error
    const options = {
      method: 'GET'
    }

    const serverRoot = this._getServerRoot();
    const request = new Request(`${serverRoot}${url}`, options);
    const response = await fetch(request);
    return response.json();
  }

  // TODO: for now, you need to supply the apiToken
  // this is dumb and need to be refactored
  post = async (apiToken, url, params = {}, options = {}) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const currentOrg = LocalStorageService.get('activeOrg');

    // use the apiToken from localstorage instead
    apiToken = LocalStorageService.get('apiToken');

    var optionsParams = {
      method: 'POST',
      headers,
      body: JSON.stringify(options),
    };

    if (apiToken) {
      optionsParams.headers = new Headers();
      optionsParams.headers.append('x-api-token', apiToken);
    }

    if (currentOrg) {
      params.orgId = currentOrg.id;
    }

    let paramsStr = '';
    if (params) {
      paramsStr = '';
      for (let key in params) {
        let value = params[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        if (paramsStr === '') {
          paramsStr += '?';
        } else {
          paramsStr += '&';
        }
        paramsStr += `${key}=${value}`;
      }
    }

    const serverRoot = this._getServerRoot();
    const request = new Request(
      `${serverRoot}${url}${paramsStr}`,
      optionsParams,
    );
    const response = await fetch(request);
    const returnResponse = await response.json();
    return returnResponse;
  };

  patch = async (apiToken, url, params = {}, options = {}) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const currentOrg = LocalStorageService.get('activeOrg');

    // use the apiToken from localstorage instead
    apiToken = LocalStorageService.get('apiToken');

    var optionsParams = {
      method: 'PATCH',
      headers,
      body: JSON.stringify(options),
    };

    if (apiToken) {
      optionsParams.headers = new Headers();
      optionsParams.headers.append('x-api-token', apiToken);
    }

    if (currentOrg) {
      params.orgId = currentOrg.id;
    }

    let paramsStr = '';
    if (params) {
      paramsStr = '';
      for (let key in params) {
        let value = params[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        if (paramsStr === '') {
          paramsStr += '?';
        } else {
          paramsStr += '&';
        }
        paramsStr += `${key}=${value}`;
      }
    }

    const serverRoot = this._getServerRoot();
    const request = new Request(
      `${serverRoot}${url}${paramsStr}`,
      optionsParams,
    );
    const response = await fetch(request);
    const returnResponse = await response.json();
    return returnResponse;
  };

  // Before login no apiToken is available so use this instead
  // which is identical to Post apart from that
  postNoToken = async (url, params = {}, options = {}) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    var optionsParams = {
      method: 'POST',
      headers,
      body: JSON.stringify(options),
    };

    let paramsStr = '';
    if (params) {
      paramsStr = '';
      for (let key in params) {
        let value = params[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        if (paramsStr === '') {
          paramsStr += '?';
        } else {
          paramsStr += '&';
        }
        paramsStr += `${key}=${value}`;
      }
    }

    const serverRoot = this._getServerRoot();
    const request = new Request(
      `${serverRoot}${url}${paramsStr}`,
      optionsParams,
    );
    const response = await fetch(request);
    const returnResponse = await response.json();
    return returnResponse;
  };

  put = async (apiToken, url, params = {}, options = {}) => {
    // check for an api key, otherwise throw an error

    if (!apiToken) {
      throw Error('Missing API Token');
    }

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    var optionsParams = {
      method: 'PUT',
      headers,
      body: JSON.stringify(options),
    };

    if (apiToken) {
      optionsParams.headers = new Headers();
      optionsParams.headers.append('x-api-token', apiToken);
    }

    const currentOrg = LocalStorageService.get('activeOrg');
    if (currentOrg) {
      params.orgId = currentOrg.id;
    }

    let paramsStr = '';
    if (params) {
      paramsStr = '';
      for (let key in params) {
        let value = params[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        if (paramsStr === '') {
          paramsStr += '?';
        } else {
          paramsStr += '&';
        }
        paramsStr += `${key}=${value}`;
      }
    }

    const serverRoot = this._getServerRoot();
    const request = new Request(
      `${serverRoot}${url}${paramsStr}`,
      optionsParams,
    );
    const response = await fetch(request);
    const returnResponse = await response.json();
    return returnResponse;
  };

  // Before login no apiToken is available so use this instead
  // which is identical to Put apart from that
  putNoToken = async (url, params = {}, options = {}) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    var optionsParams = {
      method: 'PUT',
      headers,
      body: JSON.stringify(options),
    };

    let paramsStr = '';
    if (params) {
      paramsStr = '';
      for (let key in params) {
        let value = params[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        if (paramsStr === '') {
          paramsStr += '?';
        } else {
          paramsStr += '&';
        }
        paramsStr += `${key}=${value}`;
      }
    }

    const serverRoot = this._getServerRoot();
    const request = new Request(
      `${serverRoot}${url}${paramsStr}`,
      optionsParams,
    );
    const response = await fetch(request);
    const returnResponse = await response.json();
    return returnResponse;
  };

  // TODO: for now, you need to supply the apiToken
  // this is dumb and need to be refactored
  sendDelete = async (apiToken, url, params = {}, options = {}) => {
    // check for an api key, otherwise throw an error

    if (!apiToken) {
      throw Error('Missing API Token');
    }

    let body = {
      method: 'DELETE',
      body: JSON.stringify(options),
    };

    if (apiToken) {
      body.headers = new Headers();
      body.headers.append('x-api-token', apiToken);
    }

    if (!params.orgId) {
      params.orgId = currentOrg.id;
    }

    if (!params.siteId) {
      params.siteId = currentSite?.id || null;
    }

    let paramsStr = '';
    if (params) {
      paramsStr = '';
      for (let key in params) {
        let value = params[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        if (paramsStr === '') {
          paramsStr += '?';
        } else {
          paramsStr += '&';
        }
        paramsStr += `${key}=${value}`;
      }
    }

    const serverRoot = this._getServerRoot();
    const request = new Request(`${serverRoot}${url}${paramsStr}`, body);
    const response = await fetch(request);
    return response.json();
  };

  registerPublic = async data => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    var options = {
      method: 'POST',
      headers,
    };

    const requestUrl = '/api/auth/signup';

    options.body = JSON.stringify({
      data,
    });

    const serverRoot = this._getServerRoot();
    const fullUrl = `${serverRoot}${requestUrl}`;

    console.debug(`URL ${fullUrl}`);
    const request = new Request(fullUrl, options);
    const response = await fetch(request);

    return response.json();
  };
}

// export default Api
export default new Api();
